import { render, staticRenderFns } from "./ClasesDetalleAgendamientoLab.vue?vue&type=template&id=683d0d31&"
import script from "./ClasesDetalleAgendamientoLab.vue?vue&type=script&lang=js&"
export * from "./ClasesDetalleAgendamientoLab.vue?vue&type=script&lang=js&"
import style0 from "./ClasesDetalleAgendamientoLab.vue?vue&type=style&index=0&id=683d0d31&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports